module.exports = __webpack_public_path__ + "img/new.95aa1bc4.jpg";